// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // ✅ Add this line
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDaaAr3fMPmFUIXRRXlv0mWRC2jU0j5qTk",
  authDomain: "t24agent.firebaseapp.com",
  projectId: "t24agent",
  storageBucket: "t24agent.firebasestorage.app",
  messagingSenderId: "814681367377",
  appId: "1:814681367377:web:28e30e0ab0e70968b5e970",
  measurementId: "G-05L0DBXYPB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
export const auth = getAuth(app);
